import Phaser from 'phaser';
import { inject } from '@vercel/analytics';
import { BootScene } from './scenes/BootScene.js';
import { IntroScene } from './scenes/IntroScene.js';
import { HouseScene } from './scenes/HouseScene.js';
import { LabScene } from './scenes/LabScene.js';
import { StyleAuditionScene } from './scenes/StyleAuditionScene.js';
import { MobileShell } from './MobileShell.js';

// Vercel Web Analytics — page views + visitor counts. No-op in local dev
// (sends a dev-mode event but doesn't write to the dashboard).
inject();

// Mobile = phone-only experience. The top-down pixel-house map doesn't translate
// to small touch screens, so on mobile we boot just the asset scene (so phone-app
// icon textures register) and mount MobileShell instead of the cinematic intro.
// Coarse pointer covers tablets in landscape; the width gate keeps large iPads on desktop.
const isMobile = window.matchMedia('(max-width: 820px), (pointer: coarse) and (max-width: 1024px)').matches;
window.__iwMobile__ = isMobile;

// Fixed reference size; FIT scales the canvas to the parent while preserving aspect.
// CENTER_BOTH centers the canvas in the viewport (with letterboxing if needed).
const GAME_WIDTH = 1280;
const GAME_HEIGHT = 720;

const config = {
  type: Phaser.AUTO,
  parent: 'game',
  backgroundColor: '#1a1614',
  scale: {
    mode: Phaser.Scale.FIT,
    autoCenter: Phaser.Scale.CENTER_BOTH,
    width: GAME_WIDTH,
    height: GAME_HEIGHT,
  },
  pixelArt: true,
  render: {
    antialias: false,
    pixelArt: true,
  },
  physics: {
    default: 'arcade',
    arcade: { debug: false },
  },
  scene: isMobile
    ? [BootScene]
    : [BootScene, IntroScene, HouseScene, LabScene, StyleAuditionScene],
};

// Expose globally so DOM overlays (PhoneSystem, MobileShell) can pull texture sources for icons
const game = new Phaser.Game(config);
window.__iwGame__ = game;

if (isMobile) {
  // Hide the empty canvas — the phone shell takes the whole viewport.
  document.getElementById('game').style.display = 'none';
  // BootScene fires this once all programmatic textures (including phone-app icons) are registered.
  game.events.once('iw-boot-complete', () => {
    new MobileShell();
  });
}
